<template lang="pug">
    ul
        li
            h4 MIS / SIS provider
        li
            router-link(:to="{ query: { ...$route.query, mis: null } }") All MIS / SIS
        li(v-for="r in Mis")
            router-link(:to="{ query : { ...$route.query, mis: r.id }}")
                | {{ r.nice_name }}
                // .count {{ r.school_count }}
</template>

<script>
import { sortBy } from "lodash";
import MisQuery from "@/graphql/queries/Mis";

export default {
	apollo: {
		Mis: {
			query: MisQuery,
			variables: {
				installed: true
			},
			update: r => sortBy(r.Mis, "nice_name")
		}
	}
};
</script>
